export const INTERNAL_CLIENT_REVIEW_ROUTE = "/client/$clientSlug/$month/client-review" as const;

export function buildInternalClientReviewPath(clientSlug: string, month: string, hash: string) {
  return `/client/${clientSlug}/${month}/client-review${hash}`;
}
